import VueRouter from "vue-router";

let pending = Promise.resolve();

function isSameQuery(a, b) {
  const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
  return [...keys].every((key) => String(a[key]) === String(b[key]));
}

async function replace(router, patch) {
  const { name, query } = router.currentRoute;
  const merged = { ...query, ...patch };

  if (isSameQuery(query, merged)) {
    return;
  }

  try {
    await router.replace({ name, query: merged });
  } catch (error) {
    // A concurrent navigation (e.g. the user clicking a link) supersedes this
    // one; there is nothing to recover from.
    if (!VueRouter.isNavigationFailure(error)) {
      throw error;
    }
  }
}

/**
 * Merge `patch` into the query of the current route via `router.replace`.
 *
 * Several components write their own defaults into the query while they are
 * being created. Replacing concurrently makes vue-router cancel all but the
 * last navigation and drops the other components' parameters, so the
 * replacements are queued here and every patch is merged against the route
 * that is current at the moment it runs.
 */
export function replaceQuery(router, patch) {
  const done = pending.then(() => replace(router, patch));
  pending = done.catch(() => {});
  return done;
}
